import React from 'react';
import {DndContext} from '@dnd-kit/core';
import type {ReactElement} from 'react';
import useTimeline from '../hooks/useTimeline';
import type {TimelineContextProps} from '../types';
import {TimelineProvider} from '../types';

function TimelineProviderInner(props: TimelineContextProps): ReactElement<any> {
  const timeline = useTimeline(props);
  const {children} = props;

  return <TimelineProvider value={timeline}>{children}</TimelineProvider>;
}

export function TimelineContext(props: TimelineContextProps): ReactElement<any> {
  const {children} = props;

  return (
    <DndContext {...props}>
      <TimelineProviderInner {...props}>{children}</TimelineProviderInner>
    </DndContext>
  );
}
